import { makeStyles } from "@mui/styles";
import { alpha } from "@mui/material/styles";
import theme, { ITheme } from "../../../common/theme";

export default makeStyles<ITheme>(({ palette }) => ({
  borderRoot: {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    overflow: "visible",
    pointerEvents: "none",
  },
  timerPaperRoot: {
    padding: theme.spacing(3.25),
    borderRadius: 4,
    backgroundColor: alpha(palette.error.main, 0.08),
  },
  summaryRoot: {
    backgroundColor: alpha(palette.primary.main, 0.08),
    padding: theme.spacing(4),
    display: "flex",
    borderRadius: 4,
  },
}));
